import { QuestionKidsPolicy } from "@/components/features/items/edit/_shared/ui/components/main/questions/kids-policy";

import { useKidsPolicyOfHotelPolicy } from "./hooks/use-kids-policy/use-kids-policy";

export const QuestionHotelPolicyKidsPolicy = () => {
	const {
		kidsPolicy,
		append,
		canRemoveKidsPolicyItem,
		removeKidsPolicyByIndex,
		getMinAge,
		kidsMaxAgeOptions,
		updateMaxAge,
		discountTypeOptions,
		updateDiscountType,
		ratioOptions,
		updateRatio,
		updateStaticPrice,
	} = useKidsPolicyOfHotelPolicy();

	const guide = `お部屋料金のキッズポリシーを設定できます。<br />
小ども料金を適用する年齢と、年齢ごとの料金を決めましょう。<br />
小どもの年齢区分は複数設定することが可能です。<br />
<br />
ここでの設定はプラン料金には反映されません。<br />
プラン料金にもキッズポリシーを適用させる場合は、
各プランの編集ページから設定ください。`;

	return (
		<QuestionKidsPolicy
			appendKidsPolicyItem={append}
			guide={guide}
			kidsPolicy={kidsPolicy?.value ?? undefined}
			isEdited={kidsPolicy?.isEdited}
			hasError={kidsPolicy?.hasError}
			questionKidsPolicyItemProps={{
				canRemoveKidsPolicyItem,
				kidsPolicyKidsMaxAgeMinAge: getMinAge,
				kidsPolicyKidsMaxAgeOptions: kidsMaxAgeOptions,
				changeKidsPolicyMaxAge: updateMaxAge,
				discountTypeOptions,
				changeKidsPolicyDiscountType: updateDiscountType,
				kidsPolicyRatioOptions: ratioOptions,
				changeKidsPolicyRatio: updateRatio,
				changeKidsPolicyStaticPrice: updateStaticPrice,
				removeKidsPolicyItemByIndex: removeKidsPolicyByIndex,
			}}
		/>
	);
};

QuestionHotelPolicyKidsPolicy.displayName = "QuestionHotelPolicyKidsPolicy";
